import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import React, { useEffect, useState } from 'react';
import { useLazyGetDestinationAnalyticsQuery } from '../../../../services/Api';
import LoaderSpiner from '../../../../components/loaderSpiner';

export default function DestinationsAnalytics() {
    const [trigger, { data, isLoading, error }] = useLazyGetDestinationAnalyticsQuery();
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        trigger(); 
    }, [trigger]);

    useEffect(() => {
        if (!isLoading && data && data?.data && data?.data?.countriesCityCount) {
            const transformedData = data?.data?.countriesCityCount?.map(item => ({
                name: item.country,
                value: item.value
            }));
            setChartData(transformedData);
        }
    }, [isLoading, data]); 

    if (isLoading) return <LoaderSpiner />;
    if (error) return <div>Unable to fetch data. Please check your internet connection and try again.
</div>;             

    return (
        <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
            <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">Destinations Analytics</h3>
            <div className="h-[200px] -ml-6">
                <ResponsiveContainer width="100%" height="120%">
                    <LineChart data={chartData}>
                        {/* Grid lines */}
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        {/* X-axis settings */}
                        <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12, fill: '#6B8E23' }}
                            interval={0}
                            angle={-18}
                            textAnchor="end"
                        />
                        {/* Y-axis settings */}
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12, fill: '#6B8E23' }}
                        />
                        {/* Line settings */}
                        <Line
                            type="monotone"
                            dataKey="value"
                            stroke="#34495E"
                            strokeWidth={2.5}
                            dot={{ fill: '#F7D44C', stroke: '#34495E', strokeWidth: 1.5, r: 4 }}
                        />
                        <Tooltip
                            contentStyle={{ backgroundColor: '#fff', borderRadius: '8px' }}
                            labelStyle={{ fontWeight: 'bold' }}
                            itemStyle={{ color: '#333', fontWeight: 'bold' }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}